module.exports = __webpack_public_path__ + "static/img/1_6_2.520c1096.jpg";